import React, { useState, useEffect } from 'react'
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails, Typography, Stack, Chip,
  FormControl, RadioGroup, FormControlLabel
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import {MobileDatePicker} from '@mui/lab';
import { format, addDays } from 'date-fns';
import { useParams } from 'react-router-dom'
import { useSnackbar } from 'notistack';

import { getLibraryDetails } from 'services/property';
import { getDBDateFormat, defaultTimeSlots } from 'services/commonServices';
import SeatLayout from 'components/SeatLayout';

const SeatLayoutWithAvailablityOptions = ({allowBooking=false, showBookingDetails=false, bookSeatsHandler}) => {
  const [date, setDate] = useState(null);
  const [toggleDatePicker, setToggleDatePicker] = useState(false);
  const [libraryData, setLibraryData] = useState(null);
  const { libraryId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [timeSlots, setTimeSlots] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [availabilityFilters, setAvailabilityFilters] = useState(null);

  function onChipClicked(value) {
    setToggleDatePicker(false);
    setStartTime(null);
    if(date === value ){
      setDate(null);
    }else{
      setDate(value);
    }
  }

  useEffect(() => {
    if(libraryId){
      getLibraryDetails({libraryId}).then(({response, error}) => {
        if(response){
          setLibraryData({...response});
          // buildTimeSlots();
        } else {
          setLibraryData(null);
          enqueueSnackbar((response?.message || error), {variant: 'error'});
        }
      })
    }
  }, []);

  useEffect(() => {
    if(libraryData){
      buildTimeSlots();
    }
  }, [libraryData])
  

  function buildTimeSlots() {
    const {from = null, to = null} = libraryData?.libraryDetails?.workingHours;
    if(from && to) {
      const fromHr = from.split(':')[0];
      const toHr = to.split(':')[0];
      if(fromHr && toHr){
        let filteredTimeSlots = defaultTimeSlots.filter(({time}) => (time >= fromHr) && (time < toHr));
        // filteredTimeSlots = filterTodayTimSlots([...filteredTimeSlots]);
        setTimeSlots([...filteredTimeSlots])
      }
    }
  }

  function getSelectedDate() {
    if(date){
      let selectedDate = date;
      if(date === 'today'){
        selectedDate = new Date();
      }
      if(date === 'tomorrow'){
        selectedDate = addDays(new Date(), 1);
      }
      return  getDBDateFormat(selectedDate);
    }
    return null;
  }

  useEffect(() => {
    if(libraryData) {
      if(libraryData?.library?.hourlyBookingsEnabled){
        if(date && startTime){
          const fromTime = `${startTime.toString().padStart()}:00`;
          const toTime = `${(startTime + 1).toString().padStart()}:00`;
          setAvailabilityFilters({fromDate: getSelectedDate(), toDate: getSelectedDate(), fromTime, toTime})
        }
      }else if(date) {
        const fromTime = libraryData?.libraryDetails?.workingHours?.from;
        const toTime = libraryData?.libraryDetails?.workingHours?.to;
        setAvailabilityFilters({fromDate: getSelectedDate(), toDate: getSelectedDate(), fromTime, toTime})
      } else if(date === null && startTime === null) {
        setAvailabilityFilters(null);
      }
    }
  }, [date, startTime, libraryData]);
  

  // Disbale time slots before current time if date is today
  function disableTodayTimSlots(time) {
    let date = getSelectedDate();
    if( (date && date === getDBDateFormat(new Date())) 
    ){
      return time <= new Date().getHours();
    }
    return false;
  }

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Check Availability</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{p:1}}>
                  <Stack direction={{ xs: 'column', sm:'row', md: 'row' }} spacing={1}>
                    <Chip label="Today" color={date === 'today' ? 'primary' : 'default' } clickable onClick={() => onChipClicked('today')} />
                    <Chip label="Tomorrow" color={date === 'tomorrow' ? 'primary' : 'default' } clickable onClick={() => onChipClicked('tomorrow')} />
                    <Chip
                      label={(date && date !== 'tomorrow' && date !== 'today') ? format(date, 'dd MMM, yyyy') : "Select Date"}
                      color={(date && date !== 'tomorrow' && date !== 'today') ? 'primary' : 'default' }
                      clickable
                      onClick={() => setToggleDatePicker(true)}
                    />
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <MobileDatePicker
                        className='date-with-no-edit-icon'
                        label="Select Date"
                        value={(date !== 'tomorrow' && date !== 'today') ? date : null}
                        // minDate={new Date()}
                        inputFormat="dd/MM/yyyy"
                        open={toggleDatePicker}
                        onClose={() => setToggleDatePicker(false)}
                        onAccept={(newValue) => {
                          setDate(newValue);
                          setStartTime(null);
                        }}
                        onChange={(newValue) => {
                          // setDate(newValue);
                          // setStartTime(null);
                        }}
                        clearable={true}
                        // onAccept={(data) => onDateAccepted(data)}
                        // renderInput={(params) => (null)}
                        renderInput={({ inputRef, inputProps, InputProps }) => (
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <input style={{visibility: 'hidden', width: '0', height: '0'}} type="hidden" ref={inputRef} {...inputProps} />
                            {/* {InputProps?.endAdornment} */}
                          </Box>
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
                {libraryData?.library?.hourlyBookingsEnabled ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <FormControl>
                      <RadioGroup
                        sx={{p:2 }}
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="startTime"
                        value={startTime}
                        // onChange={onDurationSelected}
                      >
                        {timeSlots.map(({time, label}, index) =>(
                          <FormControlLabel 
                            key={index}
                            // value={time} 
                            // checked={startTime === time}
                            control={
                              <Chip
                                sx={{m:.5 }}
                                label={label}
                                color={Number(startTime) === Number(time) ? "primary" : "default"}
                                clickable
                                disabled={disableTodayTimSlots(Number(time))}
                                onClick={() => setStartTime(time)}
                              />
                            }
                            label="" 
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                ): null}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{pt: 4}}>
          <SeatLayout availabilityFilters={availabilityFilters} allowBooking={allowBooking} showBookingDetails={showBookingDetails} bookSeatsHandler={bookSeatsHandler} />
        </Grid>
      </Grid>
    </Box>
  );
}
 
export default SeatLayoutWithAvailablityOptions;
